export default "__VITE_ASSET__BOsr4NW9__"